// 状态相关

// 申请状态
export const applymentStatusList = [
  { value: "DRAFT", zh: "待提交", en: "Draft" },
  { value: "INQUIRING", zh: "咨询中", en: "Inquiring" },
  { value: "QUOTING", zh: "报价中", en: "Quoting" },
  { value: "QUOTATION_AUDITING", zh: "报价已提交", en: "Quoting" },
  {
    value: "QUOTATION_AUDIT_PASS",
    zh: "报价完成",
    en: "Quotation proposed",
  },
  {
    value: "QUOTATION_AUDIT_FAIL",
    zh: "报价审批失败",
    en: "Quoting",
  },
  { value: "SUBMITTED", zh: "已提交", en: "Submitted" },
  { value: "CHECKING", zh: "初筛中", en: "Checking" },
  { value: "ILLEGAL", zh: "初筛不合格", en: "Checking Failed" },
  { value: "REJECTED", zh: "驳回", en: "Rejected" },
  { value: "CORRECTED", zh: "已修正", en: "Corrected" },
  { value: "REVISING", zh: "修订中", en: "Revising" },
  { value: "REVISE_FINISH", zh: "已修订完成", en: "Revise Completed" },
  { value: "AUDITING", zh: "复核中", en: "Reviewing" },
  { value: "AUDIT_FAIL", zh: "复核失败", en: "Review Failed" },
  { value: "AUDIT_SUCCESS", zh: "复核成功", en: "Review Passed" },
  { value: "REFUND_APPLYING", zh: "申请退款中", en: "Refund Applied" },
  {
    value: "REFUND_APPLY_DENY",
    zh: "申请退款拒绝",
    en: "Refund Checking Rejected",
  },
  {
    value: "REFUND_APPLY_AGREED",
    zh: "申请退款已确认",
    en: "Refund Checking Passed",
  },
  {
    value: "REFUND_APPLY_REJECT",
    zh: "申请退款驳回",
    en: "Refund Review Rejected",
  },
  { value: "REFUND_APPLY_PASS", zh: "申请退款通过", en: "Refund Review Passed" },
  { value: "REFUND_HANDING", zh: "退款处理中", en: "Refund Money Processing" },
  {
    value: "CANCELED",
    zh: "申请已取消",
    en: "Refund Completed & Order Canceled",
  },
  {
    value: "ACRA_APPLYING",
    zh: "更新申请中(Gov和/或 其他)",
    en: "Processing to Gov and/or other",
  },
  {
    value: "ACRA_REJECTED",
    zh: "被拒绝(来自Gov和/或 其他的回复)",
    en: "Rejected by Gov and/or other",
  },
  { value: "FINISH", zh: "已完成", en: "Order Completed" },
  {
    value: "SUSPEND_TRANSACTION_APPLYING",
    zh: "申请终止交易中",
    en: "Suspend Transaction Applying",
  },
  {
    value: "SUSPEND_TRANSACTION_APPLY_REJECT",
    zh: "申请终止交易驳回",
    en: "Suspend Transaction Apply Reject",
  },
  { value: "TERMINATED", zh: "已终止", en: "Terminated" },
  { value: "FORFEITED", zh: "已作废", en: "Forfeited" },
];
// 订单状态
export const orderStatusList = [
  { value: "UNPAID", zh: "待付款", en: "Unpaid" },
  { value: "COMPLETE", zh: "已付款", en: "Paid" },
  { value: "PARTLY_PAID", zh: "部分付款", en: "Partially Paid" },
  { value: "CLOSED", zh: "已关闭", en: "Closed" },
  { value: "FORFEITED", zh: "已作废", en: "Forfeited" },
];
// 补款单状态
export const amendsStatusList = [
  {
    value: 1,
    zh: "补款单：待付款",
    en: "Supplemental: Unpaid",
  },
  {
    value: 2,
    zh: "补款单：已付款",
    en: "Supplemental: Paid",
  },
  {
    value: -1,
    zh: "补款单：已关闭",
    en: "Supplemental: Closed",
  },
];
// 续约状态
export const renewStatusList = [
  {
    value: "RENEWING",
    zh: "续约中",
    en: "Renewing",
  },
  {
    value: "RENEWED",
    zh: "已续约",
    en: "Renewed",
  },
];
// 退款状态
export const refundStatusList = [
  {
    // 退款中
    value: "REFUNDING",
    zh: "退款中",
    en: "Refunding",
  },
  {
    // 退款成功
    value: "REFUNDED",
    zh: "退款成功",
    en: "Refunded",
  },
  {
    // 退款信息无异议，待退款
    value: "REFUND_PENDING",
    zh: "待退款",
    en: "Pending Refund",
  },
  {
    //退款失败，退款信息不全，待进一步提供退款资料
    value: "REFUND_INFO_NOT_ENOUGH",
    zh: "信息不全，退款失败",
    en: "Refund Failed due to Insufficient Info",
  },
  {
    //退款信息已补充（业务）
    value: "REFUND_INFO_UPDATED",
    zh: "退款信息已更新",
    en: "Refund Info Updated",
  },
];
